export type TermsVariant = 'A' | 'B' | 'C';

export type TermsDocumentType =
  | 'TERMS_OF_SERVICE'
  | 'PRIVACY_POLICY'
  | 'PAYMENT_AUTHORIZATION_AGREEMENT'
  | 'PLATFORM_SERVICES_AGREEMENT';

export interface TermsDocument {
  document_type: TermsDocumentType;
  document_version: string;
  url?: string;
}

export interface TermsAcceptance {
  eligible: boolean;
  variant?: TermsVariant;
  documents: TermsDocument[];
}

export const NOT_ELIGIBLE: TermsAcceptance = { eligible: false, documents: [] };

export const TERMS_ACCEPTANCE_COPY = {
  headline: 'We’ve updated our terms.',
  body: 'To ensure i2i continues to provide secure, transparent, and compliant healthcare technology services, we have updated our legal policies.',
  agreeButton: 'I Agree',
  newTabHint: '(opens in a new tab)',
  submitError:
    'We couldn’t record your acceptance. Please check your connection and try again.',
  termsChanged:
    'These documents were updated while this page was open. Please review the latest versions and select I Agree again.',
};

export const DOCUMENT_LABELS: Record<TermsDocumentType, string> = {
  TERMS_OF_SERVICE: 'Terms of Service',
  PRIVACY_POLICY: 'Privacy Policy',
  PAYMENT_AUTHORIZATION_AGREEMENT: 'Payment Authorization Agreement',
  PLATFORM_SERVICES_AGREEMENT: 'Platform and Services Agreement',
};

/** A run of plain text, or a slot filled with a link to that document. */
export type AgreementSegment = string | { document: TermsDocumentType };

const AGREEMENT_LEAD =
  'By clicking "I Agree," you acknowledge that you have read and agree to be bound by the updated ';

const TOS = { document: 'TERMS_OF_SERVICE' } as const;
const PRIVACY = { document: 'PRIVACY_POLICY' } as const;
const PAA = { document: 'PAYMENT_AUTHORIZATION_AGREEMENT' } as const;
const PSA = { document: 'PLATFORM_SERVICES_AGREEMENT' } as const;

export const AGREEMENT_SENTENCES: Record<TermsVariant, AgreementSegment[]> = {
  // Standard tenant
  A: [AGREEMENT_LEAD, TOS, ' and ', PRIVACY, '.'],
  // BBG tenant
  B: [AGREEMENT_LEAD, TOS, ', ', PRIVACY, ', and ', PAA, '.'],
  // i2iTherapy directory provider
  C: [AGREEMENT_LEAD, TOS, ', ', PRIVACY, ', and our new ', PSA, '.'],
};
